// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminFilterController from "./admin_filter_controller"
application.register("admin-filter", AdminFilterController)

import AnaliticaClicController from "./analitica_clic_controller"
application.register("analitica-clic", AnaliticaClicController)

import AnaliticaWizardController from "./analitica_wizard_controller"
application.register("analitica-wizard", AnaliticaWizardController)

import ArticleTypeNoticeController from "./article_type_notice_controller"
application.register("article-type-notice", ArticleTypeNoticeController)

import AssetSearchController from "./asset_search_controller"
application.register("asset-search", AssetSearchController)

import AvatarUploadController from "./avatar_upload_controller"
application.register("avatar-upload", AvatarUploadController)

import AvisoBloqueoController from "./aviso_bloqueo_controller"
application.register("aviso-bloqueo", AvisoBloqueoController)

import BarraCtaMovilController from "./barra_cta_movil_controller"
application.register("barra-cta-movil", BarraCtaMovilController)

import BlogEstadoController from "./blog_estado_controller"
application.register("blog-estado", BlogEstadoController)

import BlogTabUltimosComentariosController from "./blog_tab_ultimos_comentarios_controller"
application.register("blog-tab-ultimos-comentarios", BlogTabUltimosComentariosController)

import BuscandoValorController from "./buscando_valor_controller"
application.register("buscando-valor", BuscandoValorController)

import CalculadoraCuotaController from "./calculadora_cuota_controller"
application.register("calculadora-cuota", CalculadoraCuotaController)

import CampoMapeosController from "./campo_mapeos_controller"
application.register("campo-mapeos", CampoMapeosController)

import ClicAtestiguadoController from "./clic_atestiguado_controller"
application.register("clic-atestiguado", ClicAtestiguadoController)

import CodigoPostalDeEventosController from "./codigo_postal_de_eventos_controller"
application.register("codigo-postal-de-eventos", CodigoPostalDeEventosController)

import CamposSiNoController from "./campos_si_no_controller"
application.register("campos-si-no", CamposSiNoController)

import CommissionBreakdownController from "./commission_breakdown_controller"
application.register("commission-breakdown", CommissionBreakdownController)

import ComparadorVerMasController from "./comparador_ver_mas_controller"
application.register("comparador-ver-mas", ComparadorVerMasController)

import CamposSegunTipoController from "./campos_segun_tipo_controller"
application.register("campos-segun-tipo", CamposSegunTipoController)

import ComparadoresController from "./comparadores_controller"
application.register("comparadores", ComparadoresController)

import CompararBarraController from "./comparar_barra_controller"
application.register("comparar-barra", CompararBarraController)

import CompararBuscadorController from "./comparar_buscador_controller"
application.register("comparar-buscador", CompararBuscadorController)

import CompararCabeceraController from "./comparar_cabecera_controller"
application.register("comparar-cabecera", CompararCabeceraController)

import CompararGraficoController from "./comparar_grafico_controller"
application.register("comparar-grafico", CompararGraficoController)

import CompararTituloController from "./comparar_titulo_controller"
application.register("comparar-titulo", CompararTituloController)

import CompartirEnlaceController from "./compartir_enlace_controller"
application.register("compartir-enlace", CompartirEnlaceController)

import ConfetiController from "./confeti_controller"
application.register("confeti", ConfetiController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import ConfirmDeleteController from "./confirm_delete_controller"
application.register("confirm-delete", ConfirmDeleteController)

import ConfirmacionPaisController from "./confirmacion_pais_controller"
application.register("confirmacion-pais", ConfirmacionPaisController)

import ConfirmaBorradoController from "./confirma_borrado_controller"
application.register("confirma-borrado", ConfirmaBorradoController)

import ContentLoaderController from "./content_loader_controller"
application.register("content-loader", ContentLoaderController)

import ContentLoaderDivController from "./content_loader_div_controller"
application.register("content-loader-div", ContentLoaderDivController)

import ContentUpdaterController from "./content_updater_controller"
application.register("content-updater", ContentUpdaterController)

import ConversionAnaliticaController from "./conversion_analitica_controller"
application.register("conversion-analitica", ConversionAnaliticaController)

import CopyHtmlController from "./copy_html_controller"
application.register("copy-html", CopyHtmlController)

import CosteTarjetaController from "./coste_tarjeta_controller"
application.register("coste-tarjeta", CosteTarjetaController)

import CotizSelectorController from "./cotiz_selector_controller"
application.register("cotiz-selector", CotizSelectorController)

import CotizTableController from "./cotiz_table_controller"
application.register("cotiz-table", CotizTableController)

import CotizacionesSearchController from "./cotizaciones_search_controller"
application.register("cotizaciones-search", CotizacionesSearchController)

import DsBreadcrumbsController from "./ds_breadcrumbs_controller"
application.register("ds-breadcrumbs", DsBreadcrumbsController)

import EmailResultadosController from "./email_resultados_controller"
application.register("email-resultados", EmailResultadosController)

import EncuestaDeLaBajaController from "./encuesta_de_la_baja_controller"
application.register("encuesta-de-la-baja", EncuestaDeLaBajaController)

import EscuelasBuscadorController from "./escuelas_buscador_controller"
application.register("escuelas-buscador", EscuelasBuscadorController)

import EscuelasContactoController from "./escuelas_contacto_controller"
application.register("escuelas-contacto", EscuelasContactoController)

import EscuelasPantallasController from "./escuelas_pantallas_controller"
application.register("escuelas-pantallas", EscuelasPantallasController)

import FaqPaisesController from "./faq_paises_controller"
application.register("faq-paises", FaqPaisesController)

import FeaturedBrokerEditorController from "./featured_broker_editor_controller"
application.register("featured-broker-editor", FeaturedBrokerEditorController)
import FichaAnclasController from "./ficha_anclas_controller"
application.register("ficha-anclas", FichaAnclasController)

import FiltrosController from "./filtros_controller"
application.register("filtros", FiltrosController)

import FormSuccesMessageController from "./form_succes_message_controller"
application.register("form-succes-message", FormSuccesMessageController)

import FuentePreferidaController from "./fuente_preferida_controller"
application.register("fuente-preferida", FuentePreferidaController)

import HipotecasDocAcordeonController from "./hipotecas_doc_acordeon_controller"
application.register("hipotecas-doc-acordeon", HipotecasDocAcordeonController)

import HipotecasDocCesionController from "./hipotecas_doc_cesion_controller"
application.register("hipotecas-doc-cesion", HipotecasDocCesionController)

import HipotecasDocDropzoneController from "./hipotecas_doc_dropzone_controller"
application.register("hipotecas-doc-dropzone", HipotecasDocDropzoneController)

import HipotecasDocLopdController from "./hipotecas_doc_lopd_controller"
application.register("hipotecas-doc-lopd", HipotecasDocLopdController)

import HipotecasDocSubmitController from "./hipotecas_doc_submit_controller"
application.register("hipotecas-doc-submit", HipotecasDocSubmitController)

import HipotecasDocTitularesController from "./hipotecas_doc_titulares_controller"
application.register("hipotecas-doc-titulares", HipotecasDocTitularesController)

import HipotecasLopdFirmaOnlineController from "./hipotecas_lopd_firma_online_controller"
application.register("hipotecas-lopd-firma-online", HipotecasLopdFirmaOnlineController)

import IndiceFormularioController from "./indice_formulario_controller"
application.register("indice-formulario", IndiceFormularioController)

import InputCharCountController from "./input_char_count_controller"
application.register("input-char-count", InputCharCountController)

import InternalStatusAutorefreshController from "./internal_status_autorefresh_controller"
application.register("internal-status-autorefresh", InternalStatusAutorefreshController)

import InternalStatusFilterController from "./internal_status_filter_controller"
application.register("internal-status-filter", InternalStatusFilterController)

import LeadCountController from "./lead_count_controller"
application.register("lead-count", LeadCountController)

import LecturaSignificativaController from "./lectura_significativa_controller"
application.register("lectura-significativa", LecturaSignificativaController)

import MailTemplateDialogController from "./mail_template_dialog_controller"
application.register("mail-template-dialog", MailTemplateDialogController)

import MicrointervencionController from "./microintervencion_controller"
application.register("microintervencion", MicrointervencionController)

import ModalTematicasController from "./modal_tematicas_controller"
application.register("modal-tematicas", ModalTematicasController)

import ModerationController from "./moderation_controller"
application.register("moderation", ModerationController)

import MacroEventoAgendaController from "./macro_evento_agenda_controller"
application.register("macro-evento-agenda", MacroEventoAgendaController)

import MacroEventoSliderController from "./macro_evento_slider_controller"
application.register("macro-evento-slider", MacroEventoSliderController)

import MacroEventoTicketsController from "./macro_evento_tickets_controller"
application.register("macro-evento-tickets", MacroEventoTicketsController)

import NewsletterBloquesController from "./newsletter_bloques_controller"
application.register("newsletter-bloques", NewsletterBloquesController)

import NewsletterCaptadorController from "./newsletter_captador_controller"
application.register("newsletter-captador", NewsletterCaptadorController)

import NotaMediaController from "./nota_media_controller"
application.register("nota-media", NotaMediaController)

import OpenModalDialogController from "./open_modal_dialog_controller"
application.register("open-modal-dialog", OpenModalDialogController)

import PanelFiltrosController from "./panel_filtros_controller"
application.register("panel-filtros", PanelFiltrosController)

import PerfilController from "./perfil_controller"
application.register("perfil", PerfilController)

import PlayButtonController from "./play_button_controller"
application.register("play-button", PlayButtonController)

import PortadaCuentasAparecerController from "./portada_cuentas_aparecer_controller"
application.register("portada-cuentas-aparecer", PortadaCuentasAparecerController)

import PortadaCuentasCriteriosController from "./portada_cuentas_criterios_controller"
application.register("portada-cuentas-criterios", PortadaCuentasCriteriosController)

import PortadaCuentasEnPantallaController from "./portada_cuentas_en_pantalla_controller"
application.register("portada-cuentas-en-pantalla", PortadaCuentasEnPantallaController)

import PortadaCuentasFaqsController from "./portada_cuentas_faqs_controller"
application.register("portada-cuentas-faqs", PortadaCuentasFaqsController)

import PortadaCuentasGuiasController from "./portada_cuentas_guias_controller"
application.register("portada-cuentas-guias", PortadaCuentasGuiasController)

import PortadaCuentasParallaxController from "./portada_cuentas_parallax_controller"
application.register("portada-cuentas-parallax", PortadaCuentasParallaxController)

import PortadaCuentasPestanasController from "./portada_cuentas_pestanas_controller"
application.register("portada-cuentas-pestanas", PortadaCuentasPestanasController)

import PortadaCuentasPodioController from "./portada_cuentas_podio_controller"
application.register("portada-cuentas-podio", PortadaCuentasPodioController)

import PortadaCuentasSelectorApareceController from "./portada_cuentas_selector_aparece_controller"
application.register("portada-cuentas-selector-aparece", PortadaCuentasSelectorApareceController)

import RankitoMentionController from "./rankito_mention_controller"
application.register("rankito-mention", RankitoMentionController)

import RankitoPollingController from "./rankito_polling_controller"
application.register("rankito-polling", RankitoPollingController)

import RecargaPeriodicaController from "./recarga_periodica_controller"
application.register("recarga-periodica", RecargaPeriodicaController)

import RecordingConfigController from "./recording_config_controller"
application.register("recording-config", RecordingConfigController)

import RedireccionesMasivasController from "./redirecciones_masivas_controller"
application.register("redirecciones-masivas", RedireccionesMasivasController)

import RevisionDeNewslettersController from "./revision_de_newsletters_controller"
application.register("revision-de-newsletters", RevisionDeNewslettersController)

import RemoteToggleController from "./remote_toggle_controller"
application.register("remote-toggle", RemoteToggleController)

import ContadorAsistentesController from "./contador_asistentes_controller"
application.register("contador-asistentes", ContadorAsistentesController)

import ReplyFormController from "./reply_form_controller"
application.register("reply-form", ReplyFormController)

import RegionDropdownController from "./region_dropdown_controller"
application.register("region-dropdown", RegionDropdownController)

import ReportarController from "./reportar_controller"
application.register("reportar", ReportarController)

import RevelarProgresivoController from "./revelar_progresivo_controller"
application.register("revelar-progresivo", RevelarProgresivoController)

import RevisionBorradorController from "./revision_borrador_controller"
application.register("revision-borrador", RevisionBorradorController)

import RespuestaController from "./respuesta_controller"
application.register("respuesta", RespuestaController)

import RetomarSolicitudController from "./retomar_solicitud_controller"
application.register("retomar-solicitud", RetomarSolicitudController)

import RibbonCloneController from "./ribbon_clone_controller"
application.register("ribbon-clone", RibbonCloneController)

import SalaFilterController from "./sala_filter_controller"
application.register("sala-filter", SalaFilterController)

import ScoreModalController from "./score_modal_controller"
application.register("score-modal", ScoreModalController)

import ScreenerEtfsController from "./screener_etfs_controller"
application.register("screener-etfs", ScreenerEtfsController)

import SegurosAseguradoraController from "./seguros_aseguradora_controller"
application.register("seguros-aseguradora", SegurosAseguradoraController)

// simulador-pension is registered from packs/simuladores/simulador-pension.js so it
// only ships in the lazy pack loaded by posts that embed the pension widget.
// calculadora-financia-europa does the same from packs/simuladores/calculadora-financia-europa.js.

import SimuladorInversionController from "./simulador_inversion_controller"
application.register("simulador-inversion", SimuladorInversionController)

import SortableCsvController from "./sortable_csv_controller"
application.register("sortable-csv", SortableCsvController)

import StickyItemController from "./sticky_item_controller"
application.register("sticky-item", StickyItemController)

import SummaryTableCardController from "./summary_table_card_controller"
application.register("summary-table-card", SummaryTableCardController)

import SummaryTableController from "./summary_table_controller"
application.register("summary-table", SummaryTableController)

import SummaryTableExpandController from "./summary_table_expand_controller"
application.register("summary-table-expand", SummaryTableExpandController)

import SuscripcionesController from "./suscripciones_controller"
application.register("suscripciones", SuscripcionesController)

import TableSliderController from "./table_slider_controller"
application.register("table-slider", TableSliderController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TagOpinableBuscadorController from "./tag_opinable_buscador_controller"
application.register("tag-opinable-buscador", TagOpinableBuscadorController)

import TimelineCarouselController from "./timeline_carousel_controller"
application.register("timeline-carousel", TimelineCarouselController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TraducirController from "./traducir_controller"
application.register("traducir", TraducirController)

import TrixAutofocusController from "./trix_autofocus_controller"
application.register("trix-autofocus", TrixAutofocusController)

import TrixCharCountController from "./trix_char_count_controller"
application.register("trix-char-count", TrixCharCountController)

import TrixWordCountController from "./trix_word_count_controller"
application.register("trix-word-count", TrixWordCountController)

import TurboFetchController from "./turbo_fetch_controller"
application.register("turbo-fetch", TurboFetchController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import VerArbolDeCategoriasController from "./ver_arbol_de_categorias_controller"
application.register("ver-arbol-de-categorias", VerArbolDeCategoriasController)

import VerMasController from "./ver_mas_controller"
application.register("ver-mas", VerMasController)

import YoutubeDetectorController from "./youtube_detector_controller"
application.register("youtube-detector", YoutubeDetectorController)
